/**
 * Description component.
 */
import Header from '@components/sections/description/descriptionHeader';
import Content from '@components/sections/description/descriptionContent';
import DescriptionContext from '@shared/components/utils/context/descriptionContext';
import useDescription from './useDescription';

/**
 * Displays the description of the currently focused asset in a rail.
 */
export default function Description() {
  const context = useDescription();
  return (
    <DescriptionContext.Provider value={context}>
      <Header />
      <Content />
    </DescriptionContext.Provider>
  );
}
